import { v4 as uuid } from 'uuid';

export const CUSIPS_LIST_ARRAY_NAME = 'cusipLists';

export const getInitialListsValues = (portfolioId, lists) => {
  if (lists?.length) {
    return lists;
  }

  return [
    {
      id: uuid(),
      name: '',
      positions: [],
      portfolioId: portfolioId || null,
      priority: 1,
      isLocal: true,
    },
  ];
};
